import { gql } from "@apollo/client"
import { useMutation } from "@oysterhr/core"

export const REQUEST_CANCEL_RESIGNATION_MUTATION = gql`
  mutation RequestResignationCancellation($terminationId: ID!, $cancelReason: String!) {
    requestResignationCancellation(
      input: { terminationId: $terminationId, cancelReason: $cancelReason }
    ) {
      errors
    }
  }
`

export const useRequestCancellation = () => useMutation(REQUEST_CANCEL_RESIGNATION_MUTATION)
